import type { CustomFlowbiteTheme } from 'flowbite-react';

const customLinkedInModalTheme: CustomFlowbiteTheme['modal'] = {
    content: {
        base: 'relative w-full p-4 h-auto focus:ring-0 focus:outline-none focus-visible:outline-none focus-visible:ring-0', // updated
        inner: 'relative rounded-lg bg-cirrusWhite shadow dark:bg-gray-700 flex flex-col overflow-y-auto max-h-[90vh] flex flex-col gap-4 p-3 focus:outline-none focus-visible:outline-none focus-visible:ring-0', // updated
    },
};

export default customLinkedInModalTheme;
